import { CSSObject } from '@chakra-ui/react';

export const ILink: CSSObject = {
  color: 'white',
  mx: '0',
  textDecoration: 'underline',
};
